import { CircularProgress, Grid, Paper } from '@mui/material'
import React, { FC } from 'react'
import useFetch from '../hooks/useFetch'
import ContractList from './ContractList'
import Title from './Title'
interface SelectContractProps {
  justContent?: boolean
  selectedContract?: string | undefined
}
const SelectContract: FC<SelectContractProps> = ({ justContent = false, selectedContract }) => {
  const [isLoadingContracts, dataContracts, errorContracts] = useFetch('getStudies')

  if (isLoadingContracts || !dataContracts) {
    return <CircularProgress />
  }
  const content = (
    <>
      <Title>Choose contract:</Title>
      {errorContracts ? (
        <Title>Can't fetch contracts data</Title>
      ) : (
        dataContracts?.studies && <ContractList contracts={dataContracts.studies} selectedContract={selectedContract} />
      )}
    </>
  )

  return (
    <>
      {justContent ? (
        <Grid item>{content}</Grid>
      ) : (
        <Grid item xs={12} mt={4}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {content}
          </Paper>
        </Grid>
      )}
    </>
  )
}
export default SelectContract
